import { useQuery } from '@tanstack/react-query'
import { fetchPaymentTasks, UsePaymentTasksParams } from './queries'

export const useGetPaymentTasks = ({
  page = 1,
  perPage = 10,
  globalOnId = 1,
  search = '',
  programId = 0,
}: UsePaymentTasksParams = {}) => {
  return useQuery({
    queryKey: [
      'paymentTasks',
      { page, perPage, globalOnId, search, programId },
    ],
    queryFn: () =>
      fetchPaymentTasks({ page, perPage, globalOnId, search, programId }),
    refetchOnMount: 'always',
  })
}
